import React, { Fragment, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { connect } from 'react-redux';

import { hasPendingTranslations } from "../../../../../helpers/checkPendingTranslation";
import { getLanguageOptions } from "../../../../../helpers";
import TranslationsCellFormatter from "./tanslations_table_formatter";
import NewTranslationModal from "../new_translation_modal/new_translation_modal";
import EditTranslationModal from "../edit_translation_modal/edit_translation_modal";


function TranslationsCellRenderer(config) {
  const { currentLanguage, setNewTranslation, showTranslationModal, pendingTranslations, languages } = config;

  return languages.map((language) => {
    const isTranslation = language.value !== currentLanguage.value;

    return {
      text: language.text,
      title: true,
      headerTitle: true,
      headerFormatter: () => <div>{language.text}</div>,
      formatter: (_, control) => {
        return (
          <TranslationsCellFormatter
            control={control}
            language={language}
            isTranslation={isTranslation}
            showTranslationModal={showTranslationModal}
            pendingTranslations={pendingTranslations}
            openNewTranslation={(translationType) =>
              setNewTranslation({
                control,
                language,
                currentLanguage,
                translationType,
              })
            }
          />
        );
      },
    };
  });
}

function TranslationsTable(props) {
  const { controls, reloadControls, showTranslationModal, library_control } = props;
  const [newTranslation, setNewTranslation] = useState();
  const languages = getLanguageOptions();
  const currentLanguage = languages[0];
  const pendingLanguages = languages.filter(item=>item.value !== "English").map(item=>{return item.value.toLowerCase()})
  const { pendingTranslations } = library_control;

  function onCloseNewTranslation() {
    setNewTranslation();
    reloadControls();
  }

  function rowClasses(row) {
    const hasPendingTranslation = hasPendingTranslations(row, pendingTranslations, pendingLanguages);
    return hasPendingTranslation ? "disabled-row" : ""
  };

  const isNewTranslationShown = newTranslation && newTranslation.translationType === "ai";
  const isEditTranslationShown = newTranslation && newTranslation.translationType === "manual";

  return (
    <Fragment>
      <BootstrapTable
        keyField="id"
        data={controls}
        columns={TranslationsCellRenderer({
          currentLanguage,
          setNewTranslation,
          showTranslationModal,
          pendingTranslations,
          languages
        })}
        rowClasses={rowClasses}
        noDataIndication={<span className="no-data-indication">No selected control.</span>}
        tdStyle={{ whiteSpace: "normal" }}
        thStyle={{ whiteSpace: "normal" }}
        striped
        hover
        condensed
      />
      {isNewTranslationShown && <NewTranslationModal newTranslation={newTranslation} onClose={onCloseNewTranslation} />}
      {isEditTranslationShown && <EditTranslationModal newTranslation={newTranslation} onClose={onCloseNewTranslation} />}
    </Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    library_control: state.library_control,
    instanceConfig: state.instance.instanceConfig
  }
}

export default connect(mapStateToProps)(TranslationsTable);


// WEBPACK FOOTER //
// ./src/views/control_library/table/tanslations_modal/translation_modal_content/tanslations_table.js